import { useState } from 'react';
import { MessageSquare, Phone, Copy, Check, ExternalLink } from '../../icons/wp-icons';

/**
 * MessageDraft Component
 * Zeigt einen Nachrichtenentwurf mit Buttons zum Senden über verschiedene Apps
 */
export default function MessageDraft({ data }) {
  const [copied, setCopied] = useState(false);
  const { kundeName, telefon, telefonRaw, nachricht } = data;

  // Telefonnummer für internationale Formate vorbereiten
  const phoneForLinks = telefonRaw.startsWith('+')
    ? telefonRaw
    : telefonRaw.startsWith('0')
      ? '+49' + telefonRaw.substring(1)
      : telefonRaw;

  // WhatsApp Link
  const whatsappUrl = `https://wa.me/${phoneForLinks.replace(/\+/g, '')}?text=${encodeURIComponent(nachricht)}`;

  // SMS Link (funktioniert auf mobilen Geräten)
  const smsUrl = `sms:${phoneForLinks}?body=${encodeURIComponent(nachricht)}`;

  // Telefon Link
  const telUrl = `tel:${phoneForLinks}`;

  // Nachricht kopieren
  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(nachricht);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Fehler beim Kopieren:', err);
    }
  };

  return (
    <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
      {/* Header */}
      <div className="bg-gray-50 px-4 py-2 border-b border-gray-200">
        <div className="flex items-center justify-between">
          <span className="text-sm font-medium text-gray-700">
            Nachricht an {kundeName}
          </span>
          <span className="text-xs text-gray-500">
            {telefon}
          </span>
        </div>
      </div>

      {/* Nachrichtenvorschau */}
      <div className="p-4">
        <div className="bg-gray-100 rounded-lg p-3 text-sm text-gray-800 whitespace-pre-wrap">
          {nachricht}
        </div>
      </div>

      {/* Action Buttons */}
      <div className="px-4 pb-4 flex flex-wrap gap-2">
        {/* WhatsApp Button */}
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 px-4 py-2 bg-[#25D366] text-white rounded-button hover:bg-[#20bd5a] transition-colors text-sm font-medium"
        >
          <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
          </svg>
          WhatsApp
          <ExternalLink className="w-3 h-3 opacity-70" />
        </a>

        {/* SMS Button */}
        <a
          href={smsUrl}
          className="inline-flex items-center gap-2 px-4 py-2 bg-primary text-white rounded-button hover:bg-primary-dark transition-colors text-sm font-medium"
        >
          <MessageSquare className="w-4 h-4" />
          SMS
        </a>

        {/* Anrufen Button */}
        <a
          href={telUrl}
          className="inline-flex items-center gap-2 px-4 py-2 bg-gray-600 text-white rounded-button hover:bg-gray-700 transition-colors text-sm font-medium"
        >
          <Phone className="w-4 h-4" />
          Anrufen
        </a>

        {/* Kopieren Button */}
        <button
          onClick={copyToClipboard}
          className={`inline-flex items-center gap-2 px-4 py-2 rounded-lg transition-colors text-sm font-medium ${
            copied
              ? 'bg-green-100 text-green-700'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          {copied ? (
            <>
              <Check className="w-4 h-4" />
              Kopiert!
            </>
          ) : (
            <>
              <Copy className="w-4 h-4" />
              Kopieren
            </>
          )}
        </button>
      </div>
    </div>
  );
}
